import { getNavigationContext, useTypedSelector } from 'store';

export const useNavigationContext = () => {
  return useTypedSelector(getNavigationContext);
};
